import { render, staticRenderFns } from "./FAQTemplateFileViewer.vue?vue&type=template&id=63df9841&"
import script from "./FAQTemplateFileViewer.vue?vue&type=script&lang=ts&"
export * from "./FAQTemplateFileViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
